/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form, Row, Col } from 'react-bootstrap';
import {
  useForm,
  FieldValues,
  SubmitHandler,
  Controller
} from 'react-hook-form';
import { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { useTranslation } from 'react-i18next';

import Button from 'components/base/Button';
import { showAlert } from 'store/alert/alert.thunk';

interface AmountInoutForSaleProps {
  setOpenDiscountAmount: (show: boolean) => void;
  setOpenDiscountPercent: (show: boolean) => void;
  setSelectedSalesValues?: any;
  selectedOption?: string;
}
const AmountInoutForSale = ({
  setOpenDiscountAmount,
  setOpenDiscountPercent,
  setSelectedSalesValues,
  selectedOption
}: AmountInoutForSaleProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  const dispatch: Dispatch<any> = useDispatch();

  const {
    handleSubmit,
    control,
    formState: { errors }
  } = useForm();

  const inputRef = useRef<HTMLInputElement | any>();

  const onSubmit: SubmitHandler<FieldValues> = data => {
    setLoading(true);
    if (+data?.quantity === 0) {
      dispatch(
        showAlert({
          title: t('quantity_cannot_thero')
        })
      );
      setLoading(false);
      return;
    }

    if (selectedOption === 'discount-percent' && +data?.quantity > 100) {
      dispatch(
        showAlert({
          title: t('discount_percent_cannot_exceed_100')
        })
      );
      setLoading(false);
      return;
    }

    if (setSelectedSalesValues) {
      setSelectedSalesValues((prev: any) => {
        const newValues = prev.filter(
          (item: any) => item.name !== selectedOption
        );
        return [...newValues, { name: selectedOption, value: +data?.quantity }];
      });
      if (selectedOption === 'discount-amount') {
        setOpenDiscountAmount(false);
      } else if (selectedOption === 'discount-percent') {
        setOpenDiscountPercent(false);
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [inputRef.current]);

  const handleQuantityChange = (e: any, field: any) => {
    const value = e.target.value;

    if (value === '') {
      field.onChange('');
      return;
    }

    const numericValue = parseInt(value, 10);
    if (selectedOption === 'discount-percent' && numericValue > 100) {
      field.onChange(100);
    } else {
      field.onChange(numericValue);
    }
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Row className="mb-3">
        <Col>
          <Controller
            name={`quantity`}
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <Form.Floating className="md-4">
                <Form.Control
                  {...field}
                  ref={inputRef}
                  type="text"
                  placeholder={t('quantity')}
                  onFocus={e => e.target.select()}
                  onChange={e => handleQuantityChange(e, field)}
                  isInvalid={!!errors.quantity}
                />
                <label htmlFor="floatingInputCustom">{t('quantity')}</label>
                {errors.quantity && (
                  <Form.Control.Feedback type="invalid">
                    {t('required_field')}
                  </Form.Control.Feedback>
                )}
              </Form.Floating>
            )}
          />
        </Col>
      </Row>

      <Button
        className="w-100"
        variant="primary"
        type="submit"
        loading={loading}
      >
        {t('add')}
      </Button>
    </Form>
  );
};

export default AmountInoutForSale;
